const BASE_URL = 'https://api.dev.auxo.dk/public/content'

/**
 * Fetches all entries from a CMS collection.
 * @param {string} collectionName 
 * @returns {Promise<Array>}
 */
export async function fetchCollection(collectionName) {
  try {
    const response = await fetch(`${BASE_URL}/${collectionName}`)
    if (!response.ok) {
      throw new Error(`Failed to fetch collection: ${collectionName}`)
    }
    return await response.json()
  } catch (error) {
    console.error(`Error fetching CMS collection ${collectionName}:`, error)
    return []
  }
}

/**
 * Helper to extract localized text (defaults to Danish 'da').
 * @param {object|string} field 
 * @param {string} lang 
 * @returns {string}
 */
export function getLocalized(field, lang = 'da') {
  if (!field) return ''
  if (typeof field === 'string') return field
  if (typeof field === 'object') {
    return field[lang] || field['en'] || Object.values(field)[0] || ''
  }
  return String(field)
}
